if (typeof console._commandLineAPI !== 'undefined') {
    console.API = console._commandLineAPI; //Chrome
} else if (typeof console._inspectorCommandLineAPI !== 'undefined') {
    console.API = console._inspectorCommandLineAPI; //Safari
} else if (typeof console.clear !== 'undefined') {
    console.API = console;
}

// ME console log, add project information and select project appropriate emoji
// play with the colors to align with the project design
console.groupCollapsed(
  "%c Modern English \u2615️",
  "color: white; background: #000000; padding: 4px; font-size: 13px; font-weight: bold;"
); // 💿 🎶 🎙️ 📽️ 🎧 🎥
console.log(
  "%c Punk Bunny ",
  "color: white; background: #000000; padding: 4px; font-size: 12px;"
);
console.log(
  "%c Built By: modernenglish.co.uk ",
  "color: white; background: #000000; padding: 4px; font-size: 12px;"
);
console.log(
  "%c Powered By: Shopify",
  "color: white; background: #000000; padding: 4px; font-size: 12px;"
);
console.log(
  "%c For: Punk Bunny Coffee ",
  "color: white; background: #000000; padding: 4px; font-size: 12px;"
);
console.groupEnd();